import DropdownMenu from 'common/components/drop-downs/drop-down-menu';
import { Exclusion } from '../exclusions.models';
import { useAuth } from 'features/auth/hooks/useAuth';
import DropdownMenuButton from 'common/components/drop-downs/dropdown-menu-button';
import { useDispatch } from 'react-redux';
import { onExclusionToBeDeletedChanged } from './exclusions-table.slice';
import { ExclusionLevel } from '../exclusions.enums';
import { useState } from 'react';

export interface ExclusionTableActionsProps {
  exclusion: Exclusion;
}

export default function ExclusionsTableActions({
  exclusion
}: ExclusionTableActionsProps) {
  const dispatch = useDispatch();
  const { isSuperUser } = useAuth();
  const isDisabled = !isSuperUser;
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <div className="text-sm w-full flex items-center justify-center relative">
      <DropdownMenu
        isDropdownOpen={isDropdownOpen}
        buttonClasses="rounded hover:bg-neutral-100 flex items-center justify-center"
        buttonIconClasses="ra-icons-generic-menu-1 text-primary-700 flex items-center justify-center text-lg"
        dropdownMenuClasses="z-40 -top-2 right-11 w-40"
        containerClasses="flex justify-center relative"
        isDisabled={isDisabled}
        title={
          isDisabled
            ? 'Only administrators can action this Exclusion'
            : 'Click to see the available actions for this Exclusion'
        }
        onDropdownClicked={() => setIsDropdownOpen(!isDropdownOpen)}
        onClickAway={() => setIsDropdownOpen(false)}
      >
        {exclusion.exclusionLevel === ExclusionLevel.SiteSpecificManual ? (
          <DropdownMenuButton
            identifier="delete-exclusion"
            buttonClasses="flex items-center"
            iconClasses="ra-icons-generic-bin mr-2 text-neutral-500 group-hover:text-error-300 transition-all flex items-center w-fit text-lg"
            onClick={() => dispatch(onExclusionToBeDeletedChanged(exclusion))}
          >
            <span>Delete</span>
          </DropdownMenuButton>
        ) : (
          <></>
        )}
      </DropdownMenu>
    </div>
  );
}
